export default "__VITE_ASSET__CP$ofD5L__"